import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import React from "react";
import { observer } from "mobx-react";
import {
	CategoryItemButton,
	CategoryItems as CategoryItemType,
} from "../category-items";
import { TournamentItem } from "@features/offer/desktop/offer-menu/components/tournament-items";

export const CategoryItems = observer(function CategoryItems(props: {
	sport: PrematchOfferMenuStore["menu"];
	store: {
		selectedSport: PrematchOfferMenuStore["selectedSport"];
	} & Parameters<typeof CategoryItemType>[0]["store"];
}) {
	if (
		props.sport?.children == null ||
		(props.store.selectedSport == null && !props.sport.isExpanded)
	) {
		return null;
	}

	return (
		<ul className="nav--tertiary__menu">
			{props.sport.children.map((category) => (
				<li className="nav--tertiary__item">
					<CategoryItemButton
						category={category}
						store={props.store}
					/>
					<ul className="nav--quaternary">
						{category.children.map((tournament, index) =>
							category.isExpanded ? (
								<TournamentItem
									key={tournament.node.id + index}
									tournament={tournament}
									category={category}
									sport={props.sport}
									store={props.store}
								/>
							) : null
						)}
					</ul>
				</li>
			))}
		</ul>
	);
});
